import { OverlayContext } from 'constants/contexts';
import { useContext } from 'react';

function useOverlay() {
  return useContext(OverlayContext);
}

export default useOverlay;
